<p-toast key="formToast" position="{{smallScreen ? 'bottom-right' : 'bottom-right'}}"></p-toast>

<form [formGroup]="projectForm" (ngSubmit)="save()">
  <p-tabView class="pps-form" [(activeIndex)]="activeTabIndex">
    <!-- Project Info -->
    <p-tabPanel header="Project Info" rightIcon="{{errorInInfoFields() ? 'fas fa-exclamation-circle text-danger' : ''}}">
      <div class="p-fluid p-grid">
        <!-- Project No-->
        <div class="p-field p-col-12 p-md-3" *ngIf="hasAccess('ProjectNo')">
          <span class="p-float-label">
            <input pInputText id="projectNo" class="p-inputtext-sm" 
                   formControlName="projectNo" 
                   [class.field-error]="submitted && f.projectNo.errors"/>
            <label for="projectNo" class="required-field">Project No</label>
          </span>
          <small class="p-error" *ngIf="f.projectNo.hasError('minlength')">Minimal length is 7</small>
          <small class="p-error" *ngIf="f.projectNo.hasError('required')">Project no is required</small>
        </div>

        <!--Project Status-->
        <div class="p-field p-col-12 p-md-3" *ngIf="hasAccess('ProjectStatus')">
          <span class="p-float-label">
            <p-dropdown inputid="projectStatus" class="p-inputtext-sm" 
                        formControlName="projectStatus"
                        appendTo="body"
                        showClear="true"
                        [options]="projectStatuses" 
                        optionLabel="name"
                        dataKey="id"
                        [autoDisplayFirst]="false"
                        (onChange)="onProjectStatusChanged($event)"
                        [class.field-error]="submitted && f.projectStatus.errors"></p-dropdown>
            <label for="projectStatus" class="required-field">Project Status</label>
          </span>
          <small class="p-error" *ngIf="submitted && f.projectStatus.hasError('required')">Project status is required</small>
        </div>

        <!-- Po Number-->
        <div class="p-field p-col-12 p-md-3" *ngIf="poReceived && hasAccess('PoNumber')">
          <span class="p-float-label">
            <input  pInputText id="poNumber" class="p-inputtext-sm" 
                    formControlName="poNumber"
                    [class.field-error]="submitted && f.poNumber.errors"/>
            <label for="poNumber">PO Number</label>
          </span>
          <small class="p-error" *ngIf="submitted && f.poNumber.hasError('required')">
            PO# is required!
          </small>
        </div>

        <!-- PO Value-->
        <div class="p-field p-col-12 p-md-3" *ngIf="poReceived && hasAccess('PoAmount')">
          <span class="p-float-label">
            <p-inputNumber  id="poAmount" class="p-inputtext-sm"
                            formControlName="poAmount"
                            mode="decimal" 
                            prefix="$"
                            [minFractionDigits]="2"
                            [class.field-error]="submitted && f.poAmount.errors"></p-inputNumber>
            <label for="poAmount">PO Value</label>
          </span>
          <small class="p-error" *ngIf="submitted && f.poAmount.hasError('required')">
            PO value is required!
          </small>
        </div>
      </div> <!--End row 1-->

      <div class="p-fluid p-grid">
        <!-- Description -->
        <div class="p-field p-col-12 p-md-12" *ngIf="hasAccess('Description')">
          <span class="p-float-label">
            <textarea pInputTextarea id="description" class="p-inputtext-sm"
                      formControlName="description" 
                      rows="6"
                      [class.field-error]="submitted && f.description.errors"></textarea>
            <label for="description" class="required-field">Description</label>
          </span>
          <small class="p-error" *ngIf="submitted && f.description.hasError('required')">
            Project description is required
          </small>
        </div>
      </div> <!--End row 2-->

      <div class="p-fluid p-grid">
        <!-- Job Type-->
        <div class="p-field p-col-12 p-md-4" *ngIf="hasAccess('JobType')">
          <span class="p-float-label">
            <p-dropdown inputid="jobType" class="p-inputtext-sm" 
                        formControlName="jobType"
                        appendTo="body"
                        showClear="true"
                        [options]="jobTypes" 
                        optionLabel="name"
                        dataKey="id"
                        [autoDisplayFirst]="false"
                        [class.field-error]="submitted && f.jobType.errors"></p-dropdown>
            <label for="jobType" class="required-field">Job Type</label>
          </span>
          <small class="p-error" *ngIf="submitted && f.jobType.hasError('required')">
            Job type is required
          </small>
        </div>

        <!-- Responsible Engineer-->
        <div class="p-field p-col-12 p-md-4" *ngIf="hasAccess('ResponsibleEngineer')">
          <span class="p-float-label">
            <p-dropdown inputid="responsibleEngineer" class="p-inputtext-sm" 
                        formControlName="responsibleEngineer"
                        appendTo="body"
                        showClear="true"
                        [options]="responsibleEngineers" 
                        optionLabel="name"
                        dataKey="id"
                        [autoDisplayFirst]="false"
                        [class.field-error]="submitted && f.responsibleEngineer.errors">
              <ng-template let-item pTemplate="item">
                <span>{{ util.getEmployeeName(item) }}{{item.active ? "" : " - (inactive)"}}</span>
              </ng-template>                        
            </p-dropdown>
            <label for="responsibleEngineer" class="required-field">Responsible Engineer</label>
          </span>
          <small class="p-error" *ngIf="submitted && f.responsibleEngineer.hasError('required')">
            Responsible engineer is required
          </small>
        </div>

        <!-- Quoting Deadline-->
        <div class="p-field p-col-12 p-md-4" *ngIf="hasAccess('QuotingDeadline')">
          <span class="p-float-label">
            <p-calendar inputId="quotingDeadline" class="p-inputtext-sm" 
                        formControlName="quotingDeadline"
                        appendTo="body"
                        showTime="true"
                        [defaultDate]="defaultQuotingDeadline" 
                        showIcon="true" 
                        hourFormat="12"
                        dateFormat="dd/mm/yy"></p-calendar>
            <label for="quotingDeadline">Quoting Deadline</label>
          </span>
          <small class="p-error" *ngIf="submitted && f.quotingDeadline.hasError('required')">
            Deadline is required when project status is RFQ!
          </small>
        </div>
      </div> <!--End row 3-->

      <div class="p-fluid p-grid">
        <!-- Client -->
        <div class="p-field p-col-12 p-md-4" *ngIf="hasAccess('Client')">
          <span class="p-float-label">
            <p-dropdown inputid="client" class="p-inputtext-sm" 
                        formControlName="client"
                        appendTo="body"
                        showClear="true"
                        [options]="clients" 
                        optionLabel="name"
                        dataKey="id"
                        [autoDisplayFirst]="false"
                        (onChange)="onClientChange($event)">
            </p-dropdown>
            <label for="client">Client</label>
          </span>
        </div>

        <!-- Client Representative-->
        <div class="p-field p-col-12 p-md-8" *ngIf="hasAccess('ClientEngineers')">
          <span class="p-float-label">
            <p-multiSelect inputid="clientEngineer" class="p-inputtext-sm multiselect-custom"
                           formControlName="clientEngineers"
                           appendTo="body"
                           [showHeader]="false"
                           [filter]="false"
                           [showToggleAll]="false"
                           [options]="clientEngineers"                            
                           optionLabel="name"
                           dataKey="id">
            </p-multiSelect >
            <label for="clientEngineer">Client Representative(s)</label>
          </span>
        </div>
      </div> <!--End row 4-->
    </p-tabPanel>

    <!-- Material Info -->
    <p-tabPanel header="Material Info" rightIcon="{{errorInMaterialFields() ? 'fas fa-exclamation-circle text-danger' : ''}}">
      <div class="p-fluid p-grid">
        <!--Material Procurement Status-->
        <div class="p-field p-col-12 p-md-6" *ngIf="hasAccess('MaterialProcurementStatus')">
          <span class="p-float-label">
            <p-dropdown inputid="materialProcurementStatus" class="p-inputtext-sm" 
                        formControlName="materialProcurementStatus"
                        appendTo="body"
                        showClear="true"
                        [options]="materialProcurementStatuses" 
                        optionLabel="name"
                        dataKey="id"
                        [autoDisplayFirst]="false"
                        (onChange)="onMaterialStatusChanged($event)">
            </p-dropdown>
            <label for="materialProcurementStatus">Material Procurement Status</label>
          </span>
        </div>

        <!--Estimated Arrival Date-->
        <div class="p-field p-col-12 p-md-4" *ngIf="needMaterialEstimateDeliveryDate && hasAccess('MaterialEstimateDeliveryDate')">
          <span class="p-float-label">
            <p-calendar inputId="materialEstimateDeliveryDate" class="p-inputtext-sm" 
                        formControlName="materialEstimateDeliveryDate"
                        appendTo="body"
                        showIcon="true" 
                        dateFormat="dd/mm/yy"></p-calendar>
            <label for="materialEstimateDeliveryDate">Estimated Arrival Date</label>
          </span>
        </div>

        <!--Actual Arrival Date-->
        <div class="p-field p-col-12 p-md-3" *ngIf="needMaterialActualArrivalDate && hasAccess('MaterialActualArrivalDate')">
          <span class="p-float-label">
            <p-calendar inputId="materialActualArrivalDate" class="p-inputtext-sm" 
                        formControlName="materialActualArrivalDate"
                        appendTo="body"
                        showIcon="true" 
                        dateFormat="dd/mm/yy"></p-calendar>
            <label for="materialActualArrivalDate">Actual Arrival Date</label>
          </span>
        </div>

      </div> <!-- end of row 1-->

      <div class="p-fluid p-grid">
        <!--Memo-->
        <div class="p-field p-col-12 p-md-12" *ngIf="hasAccess('MaterialStatusMemo')">
          <span class="p-float-label">
            <textarea pInputTextarea id="materialStatusMemo" class="p-inputtext-sm"
                      formControlName="materialStatusMemo"
                      rows="13"></textarea>
            <label for="materialStatusMemo">Memo</label>
          </span>
        </div>
      </div> <!--End row 2-->

    </p-tabPanel>

    <!-- Project Execution -->
    <p-tabPanel header="Project Execution" rightIcon="{{errorInExecutionFields() ? 'fas fa-exclamation-circle text-danger' : ''}}">
      <div class="p-fluid p-grid">
        <!--Installation Progress-->
        <div class="p-field p-col-12 p-md-3" *ngIf="hasAccess('InstallationProgress')">
          <span class="p-float-label">
            <p-dropdown inputid="installationProgress" class="p-inputtext-sm" 
                        formControlName="installationProgress"
                        appendTo="body"
                        showClear="true"
                        [options]="installationProgresses" 
                        optionLabel="name"
                        dataKey="id"
                        [autoDisplayFirst]="false"></p-dropdown>
            <label for="installationProgress">Installation Progress</label>
          </span>
        </div>
      </div> <!--End row 1-->

      <div class="p-fluid p-grid">
        <!--Target Start Date-->
        <div class="p-field p-col-12 p-md-3" *ngIf="hasAccess('TargetStartDate')">
          <span class="p-float-label">
            <p-calendar inputId="targetStartDate" class="p-inputtext-sm"
                        formControlName="targetStartDate"
                        appendTo="body"
                        showIcon="true" 
                        dateFormat="dd/mm/yy"></p-calendar>
            <label for="targetStartDate">Target Start Date</label>
          </span>
        </div>

        <!--Target Completion Date-->
        <div class="p-field p-col-12 p-md-3" *ngIf="hasAccess('TargetCompletionDate')">
          <span class="p-float-label">
            <p-calendar inputId="targetCompletionDate" class="p-inputtext-sm" 
                        formControlName="targetCompletionDate"
                        appendTo="body"
                        showIcon="true" 
                        dateFormat="dd/mm/yy"></p-calendar>
            <label for="targetCompletionDate">Completion Date</label>
          </span>
        </div>
      </div> <!--End row 2-->

      <div class="p-fluid p-grid">
        <!-- Budget Man Hours -->
        <div class="p-field p-col-12 p-md-3" *ngIf="hasAccess('BudgetHour')">
          <span class="p-float-label">
            <p-inputNumber  inputid="budgetHour" class="p-inputtext-sm"
                            formControlName="budgetHour"
                            mode="decimal" 
                            [minFractionDigits]="2"
                            [class.field-error]="submitted && f.budgetHour.errors"></p-inputNumber>
            <label for="budgetHour">Budget Man Hours</label>
          </span>
          <small class="p-error" *ngIf="submitted && (f.budgetHour.hasError('min') || f.budgetHour.hasError('max'))">
            Valid range: 0-100,000 hours
          </small>
        </div>

        <!-- Planned Man Hours -->
        <div class="p-field p-col-12 p-md-3" *ngIf="hasAccess('PlannedHour')">
          <span class="p-float-label">
            <p-inputNumber  inputid="plannedHour" class="p-inputtext-sm"
                            formControlName="plannedHour"
                            mode="decimal" 
                            [minFractionDigits]="2"
                            [class.field-error]="submitted && f.plannedHour.errors"></p-inputNumber>
            <label for="plannedHour">Planned Man Hours</label>
          </span>
          <small class="p-error" *ngIf="submitted && (f.plannedHour.hasError('min') || f.plannedHour.hasError('max'))">
            Valid range: 0-100,000 hours
          </small>
        </div>

        <!-- Completion Percentage -->
        <div class="p-field p-col-12 p-md-3" *ngIf="hasAccess('CompletionPercentage')">
          <span class="p-float-label">
            <p-inputNumber  inputid="completionPercentage" class="p-inputtext-sm"
                            formControlName="completionPercentage"
                            mode="decimal" 
                            suffix="%"
                            [minFractionDigits]="2"
                            (input)="onCompletionPercentageChanged($event)"
                            [class.field-error]="submitted && f.completionPercentage.errors"></p-inputNumber>
            <label for="completionPercentage">Completion Percentage</label>
          </span>
          <small class="p-error" *ngIf="submitted && (f.completionPercentage.hasError('min') || f.completionPercentage.hasError('max'))">
            Valid value 0-100
          </small>
        </div>

        <!--Estimated Completion Value-->
        <div class="p-field p-col-12 p-md-3" *ngIf="hasAccess('EstimatedCompletionValue')">
          <span class="p-float-label">
            <p-inputNumber  inputid="estimatedCompletionValue" class="p-inputtext-sm"
                            formControlName="estimatedCompletionValue"
                            mode="decimal" 
                            prefix="$"
                            [minFractionDigits]="2"></p-inputNumber>
            <label for="estimatedCompletionValue">Estimated Completion Value</label>
          </span>
        </div>
      </div> <!--End row 3-->

      <div class="p-fluid p-grid">
        <!-- Work Order -->
        <div class="p-field p-col-12 p-md-3" *ngIf="hasAccess('WorkOrder')">
          <span class="p-float-label">
            <input pInputText id="workOrder" class="p-inputtext-sm"
                  formControlName="workOrder"/>
            <label for="workOrder">Work Order</label>
          </span>
        </div>

        <!--Contact Number-->
        <div class="p-field p-col-12 p-md-3" *ngIf="hasAccess('ContractNumber')">
          <span class="p-float-label">
            <input pInputText id="contractNumber" class="p-inputtext-sm"
                   formControlName="contractNumber" 
                   (change)="onContractNumberChanged($event)"/>
            <label for="contractNumber">Contract Number</label>
          </span>
        </div>

        <!-- Bank Guarantee Amount -->
        <div class="p-field p-col-12 p-md-3" *ngIf="hasAccess('BankGuaranteeAmount')">
          <span class="p-float-label">
            <p-inputNumber  id="bankGuaranteeAmount" class="p-inputtext-sm"
                            formControlName="bankGuaranteeAmount"
                            mode="decimal" 
                            prefix="$"
                            [minFractionDigits]="2"
                            [class.field-error]="submitted && f.bankGuaranteeAmount.errors"></p-inputNumber>
            <label for="bankGuaranteeAmount">Bank Guarantee Amount</label>
          </span>
          <small class="p-error" *ngIf="submitted && f.bankGuaranteeAmount.hasError('required')">
            Required when contract number is provided
          </small>
        </div>

        <!--Bank Guarantee Expiration Date-->
        <div class="p-field p-col-12 p-md-3" *ngIf="hasAccess('BankGuaranteeExpirationDate')">
          <span class="p-float-label">
            <p-calendar inputId="bankGuaranteeExpirationDate" class="p-inputtext-sm" 
                        formControlName="bankGuaranteeExpirationDate"
                        appendTo="body"
                        showIcon="true" 
                        dateFormat="dd/mm/yy"
                        [class.field-error]="submitted && f.bankGuaranteeExpirationDate.errors"></p-calendar>
            <label for="bankGuaranteeExpirationDate">Expiration Date</label>
          </span>
          <small class="p-error" *ngIf="submitted && f.bankGuaranteeExpirationDate.hasError('required')">
            Required when contract number is provided
          </small>
        </div>
      </div> <!--End row 4-->      
    </p-tabPanel>

    <!-- Project Budget -->
    <p-tabPanel header="Budget" *ngIf="showBudgetTab()">
      <!-- row 1-->
      <div class="p-fluid p-grid">
        <!--Direct labor-->
        <div class="p-field p-col-12 p-md-3" *ngIf="hasAccess('DirectLabor')">
          <span class="p-float-label">
            <p-inputNumber  inputid="directLabor" class="p-inputtext-sm"
                            formControlName="directLabor"
                            mode="decimal" 
                            prefix="$"
                            [minFractionDigits]="2"></p-inputNumber>
            <label for="directLabor">Direct Labour</label>
          </span>
        </div>

        <!--Plant and Equipment-->
        <div class="p-field p-col-12 p-md-3" *ngIf="hasAccess('PlantAndEquipment')">
          <span class="p-float-label">
            <p-inputNumber  inputid="plantAndEquipment" class="p-inputtext-sm"
                            formControlName="plantAndEquipment"
                            mode="decimal" 
                            prefix="$"
                            [minFractionDigits]="2"></p-inputNumber>
            <label for="plantAndEquipment">Plant and Equipment</label>
          </span>
        </div>
      </div> <!--End row 1-->

      <!-- row 2-->
      <div class="p-fluid p-grid">
        <!--Materials and Consumble-->
        <div class="p-field p-col-12 p-md-3" *ngIf="hasAccess('MaterialsAndConsumbles')">
          <span class="p-float-label">
            <p-inputNumber  inputid="materialsAndConsumbles" class="p-inputtext-sm"
                            formControlName="materialsAndConsumbles"
                            mode="decimal" 
                            prefix="$"
                            [minFractionDigits]="2"></p-inputNumber>
            <label for="materialsAndConsumbles">Materials and Consumbles</label>
          </span>
        </div>

        <!--Management-->
        <div class="p-field p-col-12 p-md-3" *ngIf="hasAccess('Management')">
          <span class="p-float-label">
            <p-inputNumber  inputid="management" class="p-inputtext-sm"
                            formControlName="management"
                            mode="decimal" 
                            prefix="$"
                            [minFractionDigits]="2"></p-inputNumber>
            <label for="management">Management</label>
          </span>
        </div>
      </div> <!--End row 2-->

      <!-- row 3-->
      <div class="p-fluid p-grid">
        <!-- 3rd Party -->
        <div class="p-field p-col-12 p-md-3" *ngIf="hasAccess('ThirdParty')">
          <span class="p-float-label">
            <p-inputNumber  inputid="thirdParty" class="p-inputtext-sm"
                            formControlName="thirdParty"
                            mode="decimal" 
                            prefix="$"
                            [minFractionDigits]="2"></p-inputNumber>
            <label for="thirdParty">3rd Party</label>
          </span>
        </div>
      </div> <!--End row 2-->
    </p-tabPanel>

    <!-- Project comment tab -->
    <p-tabPanel *ngIf="isExistingProject() && hasAccess('ProjectComment')" 
                header="Project Comments" 
                rightIcon="{{errorInMaterialFields() ? 'fas fa-exclamation-circle text-danger' : ''}}">
      <div class="p-fluid p-grid">
        <div class="p-col-12 p-md-5 p-m-0 p-p-0 project-comment-form" *ngIf="!readonlyAccess('ProjectComment')">
          <div class="p-fluid p-grid">
            <!-- Comment -->
            <div class="p-field p-col-12 p-md-12">
              <span class="p-float-label">
                <textarea pInputTextarea id="comment" class="p-inputtext-sm"
                          formControlName="comment" 
                          rows="15"
                          [class.field-error]="submitted && f.comment.errors"></textarea>
                <label for="comment">Comment</label>
              </span>
            </div>
          </div>

          <div class="p-fluid p-grid">
            <div class="p-field p-col-12 p-md-offset-6 p-md-3 p-mb-0">
              <button pButton pRipple label="Post" 
                      icon="far fa-comment" 
                      *ngIf="showDisplayPostButton()"
                      class="p-button p-button-raised" type="button" (click)="postComment(null)"></button>
            </div>
            <div class="p-field p-col-12 p-md-3 p-mb-0">
              <button pButton pRipple label="Reload" 
                      icon="{{loadingComment ? 'pi-fw fa fa-circle-o-notch fa-spin' : 'pi-fw fa fa-refresh'}}" 
                      class="p-button p-button-raised p-button-outlined" type="button" (click)="loadProjectComments()"></button>
            </div>
          </div>
        </div> 

        <div class="p-col-12 p-m-0 p-p-0 {{readonlyAccess('ProjectComment') ? 'p-md-12' : 'p-md-7'}}">
          <div *ngIf="loadingComment" style="height:290px;" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin fa-3x fa-fw"></i>
          </div>

          <div *ngIf="!loadingComment" style="height:290px; overflow:auto">
            <div class="project-comment p-mt-0 p-ml-2 text-justify"
              *ngFor="let comment of projectComments">
              <h4>{{util.getEmployeeName(comment.commentBy)}}</h4>
              <span>{{getDate(comment.commentDate)}}
                <button *ngIf="canEditComment(comment.addByUserId)"
                        pButton type="button" 
                        class="p-button-rounded p-button-text p-button-primary comment-edit-button" 
                        title="Click to edit your comment"
                        icon="fa fa-pencil"
                        (click)="startEditComment(comment)"></button> 
              </span>             
              
              <br>

              <ng-container *ngIf="updatingComment && commentInEditing?.commentId === comment.commentId">
                <div class="text-center">
                  <i class="fa fa-circle-o-notch fa-spin fa-3x fa-fw"></i>
                </div>
              </ng-container>
              <ng-container *ngIf="!updatingComment || updatingComment && commentInEditing?.commentId !== comment.commentId">
                <p *ngIf="commentInEditing?.commentId !== comment.commentId">{{comment.comment}}</p>
                <div *ngIf="commentInEditing?.commentId === comment.commentId">
                  <textarea pInputTextarea id="comment_{{comment.commentId}}" class="p-inputtext-sm"
                            formControlName="commentInEditing" 
                            rows="3">{{comment.comment}}</textarea>
                  <button pButton type="button" 
                          class="p-button-rounded p-button-success comment-edit-button p-mr-2" 
                          title="Click to save your changes"
                          icon="pi pi-check"
                          (click)="updateComment()"></button> 
                  <button pButton type="button" 
                          class="p-button-rounded p-button-success p-button-outlined comment-edit-button" 
                          title="Click to discard your changes"
                          icon="pi pi-times"
                          (click)="cancelCommentEditing()"></button> 
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </p-tabPanel>
    <!-- Project attachment-->
    <p-tabPanel *ngIf="isExistingProject() && hasAccess('ProjectAttachment')" 
                header="Attachment">
      <div class="p-fluid p-formgrid-del p-grid project-attachment-form">
        <div class="p-field p-col-12 p-md-3 text-center" *ngIf="!readonlyAccess('ProjectAttachment')">
          <p-fileUpload mode="advanced" 
                        name="ProjectAttachment" 
                        [maxFileSize]="30000000"
                        [url]="uploadUrl" 
                        (onBeforeUpload)="beforeProjectAttachmentUpload($event)"
                        (onUpload)="onProjectAttachmentUpload($event)" 
                        [auto]="true" 
                        chooseLabel="Upload">
            <ng-template pTemplate="content" class="p-m-0">
              <div style="height:220px; border:1px solid red; padding:10px;line-height: 200px; text-align: center; font-size:1.2rem"
                [ngClass]="{'dragOver': dragOverDropZone, 'dragOut' : !dragOverDropZone }"
                (dragover)="mouseOverDropArea($event)"
                (dragleave)="mouseOutDropArea($event)"
                (drop)="mouseOutDropArea($event)">Drop your file here</div>
            </ng-template>                        
          </p-fileUpload>          
        </div>
        <div class="p-field p-col-12 {{readonlyAccess('ProjectAttachment') ? 'p-md-12' : 'p-md-9'}}">
          <div *ngIf="loadingAttachments" style="height:290px;" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin fa-3x fa-fw"></i>
          </div>

          <p-table [value]="documents" 
                  *ngIf="!loadingAttachments"
                  [scrollable]="true" 
                  scrollHeight="270px" 
                  [resizableColumns]="true"
                  styleClass="p-datatable-gridlines">
            <ng-template pTemplate="header" *ngIf="documents.length > 0">
                <tr>
                    <th pResizableColumn >Document</th>
                    <th pResizableColumn [style]="{'flex':'0 0 85px'}">Size (Bytes)</th>
                    <th pResizableColumn [style]="{'flex':'0 0 105px'}">Upload By</th>
                    <th pResizableColumn [style]="{'flex':'0 0 125px'}">Upload Date</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-document>
                <tr>
                    <td>
                      <button pButton pRipple type="button" icon="pi pi-download" class="p-button-rounded p-button-text" 
                              title="Click to download the attachment"
                              (click)="downloadAttachment(document.filename, document.originalFile)"></button>
                      <button *ngIf="!readonlyAccess('ProjectAttachment')"
                              pButton pRipple type="button" icon="pi pi-times-circle" class="p-button-rounded p-button-text p-button-danger"
                              title="Click to delete the attachment"
                              (click)="deleteAttachment(document.filename, document.originalFile)"></button>
                      {{document.originalFile}}
                      
                    </td>
                    <td [style]="{'flex':'0 0 85px'}">{{util.formatNumber(document.size)}}</td>
                    <td [style]="{'flex':'0 0 105px'}">{{util.getEmployeeName(document.addBy)}}</td>
                    <td [style]="{'flex':'0 0 125px'}">{{getUploadDate(document.addDate)}}</td>
                </tr>
            </ng-template>
          </p-table>          
        </div>
      </div>      
    </p-tabPanel>

  </p-tabView>

  <div class="modal-footer">
    <button pButton pRipple label="Save" class="p-button p-button-raised" icon="pi pi-save" type="submit"></button>
    <button pButton pRipple label="Reset" class="p-button p-button-raised p-button-outlined" type="reset" (click)="reset()" *ngIf="isNewProject()"></button>
    <button pButton pRipple label="Cancel" class="p-button p-button-raised p-button-outlined" icon="pi pi-times" type="button" (click)="cancel();"></button>
  </div>
</form>

<p-confirmDialog #cd key="deleteAttachment" [style]="{width: '600px'}">
  <p-footer>
    <button type="button" pButton accesskey="y" icon="pi-fw fas fa-trash-alt" class="p-button-raised p-button-danger" label="Yes" (click)="cd.accept()"></button>
    <button type="button" pButton accesskey="n" icon="pi pi-fw pi-times" class="p-button-raised p-button-outlined" label="No" (click)="cd.reject()"></button>
  </p-footer>
</p-confirmDialog>
